import { ChangeDetectionStrategy, Component, DestroyRef, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { MatSidenavModule } from '@angular/material/sidenav';
import { filter } from 'rxjs';
import { Header } from './header/header';
import { Navigation } from './navigation/navigation';
import { SidenavAutosizeFixDirective } from '../../directives/sidenav-autosize-fix/sidenav-autosize-fix.directive';
import { PageHeaderRouteData, PageHeaderStore } from '../../../shared/stores/page-header.store';

@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [RouterOutlet, MatSidenavModule, Header, Navigation, SidenavAutosizeFixDirective],
  templateUrl: './layout.html',
  styleUrl: './layout.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Layout {
  private readonly router = inject(Router);
  private readonly destroyRef = inject(DestroyRef);
  private readonly pageHeaderStore = inject(PageHeaderStore);

  /** Whether the sidenav is expanded (full width). When false, only icons are visible. */
  readonly sidenavExpanded = signal(true);

  constructor() {
    this.syncPageHeader();

    this.router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe(() => this.syncPageHeader());
  }

  /** Run on navigation button toggling navbar */
  onSidenavToggled(expanded: boolean): void {
    this.sidenavExpanded.set(expanded);
  }

  private syncPageHeader(): void {
    let route = this.router.routerState.root;

    while (route.firstChild) {
      route = route.firstChild;
    }

    this.pageHeaderStore.syncFromRouteData(route?.snapshot?.data as PageHeaderRouteData);
  }
}
